import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import axios from 'axios';
import VueClipboard from 'vue-clipboard2';

import 'element-ui/lib/theme-chalk/index.css'; // 默认主题
import './assets/css/theme-green/index.css'; // 浅绿色主题
import './assets/css/icon.css';

Vue.config.productionTip = false

/**
 * ElementUI配置并生效，全局使用
 */
Vue.use(ElementUI, {
  size: 'small'
});

// 自定义 $message 方法，支持百分比偏移
import { Message } from 'element-ui';

const percentOffset = (percent) => {
  const windowHeight = window.innerHeight;
  return (percent / 100) * windowHeight;
};

const originalMessage = Message;
Vue.prototype.$message = (options) => {
  if (typeof options === 'string') {
    options = { message: options };
  }
  // 设置百分比偏移量 (例如：20%)
  const offsetPercent = 15;
  options.offset = percentOffset(offsetPercent);
  return originalMessage(options);
};


Vue.use(VueClipboard);


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js